import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import BlockNewEditForm from './BlockNewEditForm';
// ----------------------------------------------------------------------

export default function BlockCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit ? `${translate('Block.AddTitle')}` : `${translate('Block.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('Block.CreateBlock')}`
              : `${translate('Block.EditBlock')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('Block.BlockList')}`,
              href: PATH_DASHBOARD.Block.list,
            },
            {
              name: !isEdit
                ? `${translate('Block.New')}`
                : `${translate('Block.Update')}`,
            },
          ]}
        />
        <BlockNewEditForm />
      </Container>
    </Page>
  );
}
